import React from 'react';
import {Panel, Pagination, ListGroup, ListGroupItem, Button} from 'react-bootstrap';
import Select from './ui/Select';
import _ from 'lodash';
import PropTypes from 'prop-types';
/*import classNames from 'classnames';
 import Close from './../icons/close-icon.js';
 import ArrowIn from './../icons/arrow-in.js';
 import ArrowOut from './../icons/arrow-out.js';
 import ArrowDown from './../icons/arrow-down.js';*/

// TODO read from config
const pagerOptions = [
    {value: 10, label: '10'},
    {value: 25, label: '25'},
    {value: 50, label: '50'},
    {value: 100, label: '100'},
    {value: 250, label: '250'},
    {value: 500, label: '500'}
];

class ResultRow extends React.PureComponent {
    getOrgName() {
        const self = this;

        function currentOrganization(value) {
            if (self.props.result.organization === value.id) {
                return value.name;
            }
        }

        let currentOrgName = this.props.orgs.filter(currentOrganization);
        let currName = currentOrgName.length ? currentOrgName[0].name : '';
        return currName;
    }

    getIconAppType(type) {

        //TODO: create sprite of svgs

        const client_android = `<svg fill="#6CB24A" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="26px" height="26px" viewBox="0 0 96 96" enable-background="new 0 0 96 96" xml:space="preserve">
                        <g>
                            <circle cx="27" cy="18.5" r="10.4"/>
                            <path d="M57.6,20.2c-2.6-2.6-7.3-2.2-10.4,0.9L36.6,31.9H16.3c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8v16c0,4.4,3.6,8,8,8h5.3
                                c4.4,0,8-3.6,8-8V58.6c0-0.5,0-0.9-0.1-1.3c0.1-0.4,0.1-0.9,0.1-1.3v-6.1l19-19.2C59.8,27.5,60.2,22.8,57.6,20.2z"/>
                        </g>
                        <path d="M87.8,88v-2.2c-0.1-0.6-0.2-1.3-0.3-1.9c-1.1-5.4-4.9-10-10.1-12.7l3.2-5.9c0.2-0.4,0.1-0.8-0.3-1c-0.4-0.2-0.8-0.1-1,0.3
                            l-3.2,6c-2.8-1.2-5.8-1.8-9.1-1.8c-3.3,0-6.4,0.7-9.2,1.9l-3.3-6c-0.2-0.4-0.7-0.5-1-0.3c-0.4,0.2-0.5,0.7-0.3,1l3.2,5.9
                            c-5,2.6-8.6,6.9-9.9,12c-0.3,1.3-0.5,2.7-0.5,4.1c0,0.2,0,0.4,0,0.6H87.8z M76.4,76.7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2
                            c-1.1,0-2-0.9-2-2C74.5,77.5,75.4,76.7,76.4,76.7z M57.4,76.7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2
                            C55.4,77.5,56.3,76.7,57.4,76.7z"/>
                        </svg>`;

        const client_ios = `<svg fill="#B2B7BB" version="1.1"  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="26px" height="26px" viewBox="0 0 96 96" enable-background="new 0 0 96 96" xml:space="preserve">
                        <g>
                            <circle cx="27" cy="18.5" r="10.4"/>
                            <path d="M57.6,20.2c-2.6-2.6-7.3-2.2-10.4,0.9L36.6,31.9H16.3c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8v16c0,4.4,3.6,8,8,8h5.3
                                c4.4,0,8-3.6,8-8V58.6c0-0.5,0-0.9-0.1-1.3c0.1-0.4,0.1-0.9,0.1-1.3v-6.1l19-19.2C59.8,27.5,60.2,22.8,57.6,20.2z"/>
                        </g>
                        <path d="M83.2,71.4c0,5.4,4.7,7.1,4.8,7.2c0,0.1-0.7,2.5-2.5,5c-1.5,2.2-3,4.3-5.4,4.4c-2.4,0-3.1-1.4-5.8-1.4
                            c-2.7,0-3.6,1.4-5.8,1.5c-2.3,0.1-4.1-2.3-5.6-4.5c-3-4.4-5.4-12.4-2.2-17.9c1.6-2.7,4.3-4.4,7.3-4.4c2.3,0,4.4,1.5,5.8,1.5
                            c1.4,0,4-1.9,6.8-1.6c1.2,0,4.4,0.5,6.5,3.5C86.9,64.8,83.2,66.9,83.2,71.4 M78.8,58.2c1.2-1.5,2.1-3.6,1.8-5.7
                            c-1.8,0.1-3.9,1.2-5.2,2.7c-1.1,1.3-2.2,3.4-1.9,5.5C75.5,60.9,77.5,59.7,78.8,58.2"/>
                        </svg>`;

        const driver_android = `<svg fill="#6CB24A" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="26px" height="26px" viewBox="0 0 96 96" enable-background="new 0 0 96 96" xml:space="preserve">
                        <path d="M54.9,17c-0.6-1.7-2.2-3-4.2-3h-7.3V8.1H25.7V14h-7.3c-1.9,0-3.6,1.2-4.2,3L8.1,34.6v23.5c0,1.6,1.3,2.9,2.9,2.9H14
                            c1.6,0,2.9-1.3,2.9-2.9v-2.9h35.3v2.9c0,1.6,1.3,2.9,2.9,2.9h2.9c1.6,0,2.9-1.3,2.9-2.9V34.6L54.9,17z M18.4,46.3
                            c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4C22.8,44.3,20.8,46.3,18.4,46.3z M50.7,46.3c-2.4,0-4.4-2-4.4-4.4
                            c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C55.1,44.3,53.2,46.3,50.7,46.3z M14,31.6l4.4-13.2h32.3l4.4,13.2H14z"/>
                        <path d="M87.8,88v-2.2c-0.1-0.6-0.2-1.3-0.3-1.9c-1.1-5.4-4.9-10-10.1-12.7l3.2-5.9c0.2-0.4,0.1-0.8-0.3-1
                            s-0.8-0.1-1,0.3l-3.2,6c-2.8-1.2-5.8-1.8-9.1-1.8c-3.3,0-6.4,0.7-9.2,1.9l-3.3-6c-0.2-0.4-0.7-0.5-1-0.3c-0.4,0.2-0.5,0.7-0.3,1
                            l3.2,5.9c-5,2.6-8.6,6.9-9.9,12C46.2,84.6,46,86,46,87.4c0,0.2,0,0.4,0,0.6H87.8z M76.4,76.7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2
                            C74.5,77.5,75.4,76.7,76.4,76.7z M57.4,76.7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2C55.4,77.5,56.3,76.7,57.4,76.7z"/>
                        </svg>`;

        const driver_ios = `<svg fill="#B2B7BB" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="26px" height="26px" viewBox="0 0 96 96" enable-background="new 0 0 96 96" xml:space="preserve">
                        <path d="M83.2,71.4c0,5.4,4.7,7.1,4.8,7.2c0,0.1-0.7,2.5-2.5,5c-1.5,2.2-3,4.3-5.4,4.4c-2.4,0-3.1-1.4-5.8-1.4
                            c-2.7,0-3.6,1.4-5.8,1.5c-2.3,0.1-4.1-2.3-5.6-4.5c-3-4.4-5.4-12.4-2.2-17.9c1.6-2.7,4.3-4.4,7.3-4.4c2.3,0,4.4,1.5,5.8,1.5
                            c1.4,0,4-1.9,6.8-1.6c1.2,0,4.4,0.5,6.5,3.5C86.9,64.8,83.2,66.9,83.2,71.4 M78.8,58.2c1.2-1.5,2.1-3.6,1.8-5.7
                            c-1.8,0.1-3.9,1.2-5.2,2.7c-1.1,1.3-2.2,3.4-1.9,5.5C75.5,60.9,77.5,59.7,78.8,58.2"/>
                        <path d="M54.9,17c-0.6-1.7-2.2-3-4.2-3h-7.3V8.1H25.7V14h-7.3c-1.9,0-3.6,1.2-4.2,3L8.1,34.6v23.5c0,1.6,1.3,2.9,2.9,2.9H14
                            c1.6,0,2.9-1.3,2.9-2.9v-2.9h35.3v2.9c0,1.6,1.3,2.9,2.9,2.9h2.9c1.6,0,2.9-1.3,2.9-2.9V34.6L54.9,17z M18.4,46.3
                            c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4C22.8,44.3,20.8,46.3,18.4,46.3z M50.7,46.3c-2.4,0-4.4-2-4.4-4.4
                            c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C55.1,44.3,53.2,46.3,50.7,46.3z M14,31.6l4.4-13.2h32.3l4.4,13.2H14z"/>
                        </svg>`;

        const client_android_2 = `<svg fill="#6CB24A" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="26px" height="26px" viewBox="0 0 96 96" enable-background="new 0 0 96 96" xml:space="preserve">
                        <g>
                            <circle cx="27" cy="18.5" r="10.4"/>
                            <path d="M57.6,20.2c-2.6-2.6-7.3-2.2-10.4,0.9L36.6,31.9H16.3c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8v16c0,4.4,3.6,8,8,8h5.3
                                c4.4,0,8-3.6,8-8V58.6c0-0.5,0-0.9-0.1-1.3c0.1-0.4,0.1-0.9,0.1-1.3v-6.1l19-19.2C59.8,27.5,60.2,22.8,57.6,20.2z"/>
                        </g>
                        <path d="M87.8,88v-2.2c-0.1-0.6-0.2-1.3-0.3-1.9c-1.1-5.4-4.9-10-10.1-12.7l3.2-5.9c0.2-0.4,0.1-0.8-0.3-1c-0.4-0.2-0.8-0.1-1,0.3
                            l-3.2,6c-2.8-1.2-5.8-1.8-9.1-1.8c-3.3,0-6.4,0.7-9.2,1.9l-3.3-6c-0.2-0.4-0.7-0.5-1-0.3c-0.4,0.2-0.5,0.7-0.3,1l3.2,5.9
                            c-5,2.6-8.6,6.9-9.9,12c-0.3,1.3-0.5,2.7-0.5,4.1c0,0.2,0,0.4,0,0.6H87.8z M76.4,76.7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2
                            c-1.1,0-2-0.9-2-2C74.5,77.5,75.4,76.7,76.4,76.7z M57.4,76.7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2
                            C55.4,77.5,56.3,76.7,57.4,76.7z"/>
                        <g>
                            <path d="M88.1,38h-21v-4.2L77,23.3c1.4-1.5,2.4-2.8,3-3.9c0.7-1.1,1-2.2,1-3.2c0-1.4-0.3-2.4-1-3.2c-0.7-0.8-1.7-1.2-2.9-1.2
                                c-1.4,0-2.5,0.5-3.3,1.4c-0.8,0.9-1.2,2.2-1.2,3.7h-6.1c0-1.9,0.4-3.6,1.3-5.1c0.9-1.5,2.1-2.8,3.8-3.6C73.2,7.4,75.1,7,77.1,7
                                c3.2,0,5.6,0.8,7.4,2.3s2.6,3.7,2.6,6.4c0,1.5-0.4,3.1-1.2,4.6s-2.1,3.4-4,5.5l-7,7.3h13.2V38z"/>
                        </g>
                        </svg>`;

        const client_ios_2 = `<svg fill="#B2B7BB" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="26px" height="26px" viewBox="0 0 96 96" enable-background="new 0 0 96 96" xml:space="preserve">
                        <g>
                            <circle cx="27" cy="18.5" r="10.4"/>
                            <path d="M57.6,20.2c-2.6-2.6-7.3-2.2-10.4,0.9L36.6,31.9H16.3c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8v16c0,4.4,3.6,8,8,8h5.3
                                c4.4,0,8-3.6,8-8V58.6c0-0.5,0-0.9-0.1-1.3c0.1-0.4,0.1-0.9,0.1-1.3v-6.1l19-19.2C59.8,27.5,60.2,22.8,57.6,20.2z"/>
                        </g>
                        <path d="M83.2,71.4c0,5.4,4.7,7.1,4.8,7.2c0,0.1-0.7,2.5-2.5,5c-1.5,2.2-3,4.3-5.4,4.4c-2.4,0-3.1-1.4-5.8-1.4
                            c-2.7,0-3.6,1.4-5.8,1.5c-2.3,0.1-4.1-2.3-5.6-4.5c-3-4.4-5.4-12.4-2.2-17.9c1.6-2.7,4.3-4.4,7.3-4.4c2.3,0,4.4,1.5,5.8,1.5
                            c1.4,0,4-1.9,6.8-1.6c1.2,0,4.4,0.5,6.5,3.5C86.9,64.8,83.2,66.9,83.2,71.4 M78.8,58.2c1.2-1.5,2.1-3.6,1.8-5.7
                            c-1.8,0.1-3.9,1.2-5.2,2.7c-1.1,1.3-2.2,3.4-1.9,5.5C75.5,60.9,77.5,59.7,78.8,58.2"/>
                        <g>
                            <path d="M88.1,38h-21v-4.2L77,23.3c1.4-1.5,2.4-2.8,3-3.9c0.7-1.1,1-2.2,1-3.2c0-1.4-0.3-2.4-1-3.2
                                s-1.7-1.2-2.9-1.2c-1.4,0-2.5,0.5-3.3,1.4s-1.2,2.2-1.2,3.7h-6.1c0-1.9,0.4-3.6,1.3-5.1s2.1-2.8,3.8-3.6C73.2,7.4,75.1,7,77.1,7
                                c3.2,0,5.6,0.8,7.4,2.3s2.6,3.7,2.6,6.4c0,1.5-0.4,3.1-1.2,4.6s-2.1,3.4-4,5.5l-7,7.3h13.2V38z"/>
                        </g>
                        </svg>`;

        switch (type) {
            case 1:
                return <div style={{height: '26px'}} dangerouslySetInnerHTML={{__html: client_android}}/>;
            case 2:
                return <div style={{height: '26px'}} dangerouslySetInnerHTML={{__html: client_ios}}/>;
            case 3:
                return <div style={{height: '26px'}} dangerouslySetInnerHTML={{__html: driver_android}}/>;
            case 4:
                return <div style={{height: '26px'}} dangerouslySetInnerHTML={{__html: driver_ios}}/>;
            case 5:
                return <div style={{height: '26px'}} dangerouslySetInnerHTML={{__html: client_android_2}}/>;
            case 6:
                return <div style={{height: '26px'}} dangerouslySetInnerHTML={{__html: client_ios_2}}/>;
            default:
                return;
        }
    }

    render() {
        const attributes = _.omit(this.props, Object.keys(ResultRow.propTypes));
        debugger;
        return (
            <ListGroupItem {...attributes} className={this.props.active ? " active-item" : ""}>
                <div onClick={this.props.onClickRow} className="item-info ml1">
                    <div className="flex_row">{this.getIconAppType(this.props.result.type)}
                        <p className="item-name" style={{marginLeft: '10px'}}>{this.props.result.description}</p></div>
                    <p className="parent-name">{this.getOrgName() ? this.getOrgName() : ''}</p>
                    {this.props.result.disabled && <span className="item-removed">ОТКЛЮЧЕНО</span>}
                </div>
            </ListGroupItem>
        );
    }
}

ResultRow.propTypes = {
    result: PropTypes.object,
    orgs: PropTypes.array,
    onClickRow: PropTypes.func,
    onMarkRow: PropTypes.func,
    active: PropTypes.bool
};

//
class ResultsPanel extends React.Component {
    static propTypes = {};

    state = {
        activePage: 1,
        pageSize: 99992500,
        results: [],
        selection: [],
        app: {}
    };

    constructor(props) {
        super(props);
        this.handleSelectPage = this.handleSelectPage.bind(this);
        this.handleSelectRow = this.handleSelectRow.bind(this);
        this.getHeader = this.getHeader.bind(this);
        this.getFilteredResults = this.getFilteredResults.bind(this);
    }

    handleSelectPage(eventKey) {
        this.props.onSelectPage(eventKey);
    }

    isSelected(result) {
        return _.findIndex(this.state.selection, ['id', result.id]) > -1;
    }

    onSelectRow(result, append) {
        // this.saveChangesImmediately(); // Force save changes
        append = append || false;
        let newSelection = [];
        if (append) {
            if (!this.isSelected(result)) {
                newSelection = _.cloneDeep(this.state.selection);
                newSelection.push(result);
            } else {
                newSelection = _.pullAllBy(this.state.selection, [result], 'id');
            }
        } else {
            newSelection.push(result);
        }
        this.setState({
            selection: newSelection
        });
        document.body.scrollTop = 0;
    }

    handleSelectRow(result, append) {
        this.props.handleSelectApp(result);
        append = append || false;
        this.onSelectRow && this.onSelectRow(_.cloneDeep(result), append);
    }

    getFilteredResults() {
        return _.cloneDeep(this.props.results) || [];
    }

    getNumPages() {
        return Math.ceil(this.getFilteredResults().length / this.state.pageSize) || 0;
    }

    getCurPage() {
        let num_pages = this.getNumPages();
        return Math.min(this.props.activePage, num_pages);
    }

    getResultsPage(page) {
        page = Math.min(page, this.getNumPages()) || 1;
        const rpp = this.state.pageSize || 2500;
        const start = (page - 1) * rpp;
        return this.getFilteredResults().slice(start, start + rpp);
    }

    getHeader(totalCount) {
        return (
            <div className="flex-col-couple row-indent">
                <div className="f-between mb1">
	                <span className="font-bold-sm">
	                    {totalCount > 0 && <span className="text-muted">{totalCount}</span>}
                        {
                            totalCount === 1 ?
                                ' РЕЗУЛЬТАТ' : totalCount >= 2 && totalCount <= 4 ?
                                ' РЕЗУЛЬТАТА' : ' РЕЗУЛЬТАТОВ'
                        }
	                </span>
                    <Button className="close close-btn" onClick={this.props.onClose}>
                        x
                    </Button>
                </div>
            </div>
        );
    }

    getFooter() {
        const num_pages = this.getNumPages();
        const cur_page = this.getCurPage();
        return (
            <div className="wrapper row-indent">
                {
                    num_pages > 1 && <Pagination
                        items={num_pages}
                        activePage={cur_page}
                        prev={'<'}
                        next={'>'}
                        ellipsis
                        maxButtons={6}
                        onSelect={this.handleSelectPage}/>
                }
                <div className="controls pr">
                    {<Select className="page-size-select open-up" options={pagerOptions}
                             value={this.state.pageSize} clearable={false} searchable={false}
                             onChange={(newVal) => {
                                 this.setState({pageSize: newVal.value || 25});
                             }}
                    />}
                </div>
            </div>
        );
    }

    render() {
        if (this.props.results.length > 0) {

            const _this = this;
            const attributes = _.omit(this.props, Object.keys(ResultsPanel.propTypes));
            const totalCount = this.getFilteredResults().length;
            let rows = [];

            this.getResultsPage(this.getCurPage()).forEach(function (result) {
                const selected = (_.findIndex(_this.props.selection, ['id', result.id]) > -1);
                rows.push(<ResultRow
                    result={result}
                    orgs={_this.props.orgs}
                    key={result.id}
                    active={selected}
                    onClickRow={_this.handleSelectRow.bind(this, result, false)}
                    onMarkRow={_this.handleSelectRow.bind(this, result, true)}
                />);
            });
            return (
                <Panel {...attributes} className={' results-panel erreoi'} header={this.getHeader(totalCount)}
                       footer={this.getFooter()}>
                    <ListGroup className="scroll-wrapper" fill>
                        {rows}
                    </ListGroup>
                </Panel>
            );
        }
        return null;
    }
}

ResultsPanel.propTypes = {
    results: PropTypes.array,
    orgs: PropTypes.array,
    filter: PropTypes.object,
    selection: PropTypes.object,
    activePage: PropTypes.number,
    onSelectRow: PropTypes.func,
    onSelectPage: PropTypes.func,
    handleSelectApp: PropTypes.func,
    onClose: PropTypes.func
};

export default ResultsPanel;


// WEBPACK FOOTER //
// ./src/components/ResultPanel.js